export default function AboutSection() {
  return (
    <section id="about" className="bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[800px] mx-auto text-center">
          <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-2xl bg-primary-100">
            <i className="ri-movie-2-line text-2xl text-primary-600"></i>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-6">
            关于51电影网
          </h2>
          <div className="text-sm md:text-base text-foreground-500 leading-relaxed space-y-4 max-w-[640px] mx-auto">
            <p>
              51电影网是国内领先的影视娱乐资讯聚合平台，专注电影上映排期、
              幕后花絮揭秘、明星动态追踪、票房数据分析和争议事件深度报道。
            </p>
            <p>
              我们的编辑团队由资深娱乐记者、专业影评人和数据分析师组成，
              每日产出超过200条独家影视资讯，覆盖院线新片、流媒体热播、
              行业八卦到深度影评，为影迷提供一站式追踪体验。
            </p>
            <p>
              51电影网坚持独立客观的内容立场，不依附于任何影视公司或明星团队，
              致力于为中国影迷提供真实、丰富、及时的影视圈全方位资讯服务。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}